'use client'

import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'

import Icon from '@/legacy-src/components/icons/Icon'
import { useCompanyBenefitsSearchParams } from '@/legacy-src/hooks/useCompanyBenefitsSearchParams'

const benefit1 = {
  title: 'components.companyBenefits.list.title1',
  text: 'components.companyBenefits.list.text1',
  iconName: 'code',
}
const benefit2 = {
  title: 'components.companyBenefits.list.title2',
  text: 'components.companyBenefits.list.text2',
  iconName: 'pencil',
}
const benefit3 = {
  title: 'components.companyBenefits.list.title3',
  text: 'components.companyBenefits.list.text3',
  iconName: 'user',
}

export const CompanyPublicBenefitsList = () => {
  const { t } = getTranslate()

  const { activationLinkId, blinkClientId } = useCompanyBenefitsSearchParams()

  const benefits = activationLinkId || blinkClientId ? [benefit2, benefit3] : [benefit1, benefit2, benefit3]

  return (
    <>
      {benefits.map((item, key) => {
        const order = key + 1
        return (
          <div key={`company-benefits-${key}`} className="mb-5 flex flex-wrap tablet:mb-12 tablet:flex-nowrap">
            <div className="my-6 flex w-full justify-start tablet:m-0 tablet:w-1/5 tablet:justify-center">
              <div className={`flex flex-col justify-center px-8 font-bold`}>
                <div className="text-center text-primary tablet:block">
                  {t(`howItWorks.process.list.order${order}`)}
                </div>
                <div className="text-center text-6xl text-text-color">{order}</div>
              </div>
            </div>
            <div className={'min-h-[145px] w-full rounded-xl bg-blue-500 px-6 py-8 tablet:w-4/5 tablet:py-8 lg:px-16'}>
              <div className="grid h-full grid-cols-1 items-center tablet:grid-cols-2">
                <h3 className="mb-6 text-2xl tablet:mb-0 tablet:pr-4">{t(item.title)}</h3>{' '}
                <div className="flex items-center text-secondary">
                  <div>
                    <Icon icon={item.iconName} size="md" color="primary" className="mr-6" />
                  </div>
                  <Markdown>{t(item.text)}</Markdown>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}
